import React from 'react';

import { FTimelineLogItemFragment } from '@dashboard/generated/wp/platform';
import { getTimelineLogItemIcon, getTimelineLogItemLabel } from '@dashboard/models/TimelineLogItem';
import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import { Stack, Typography } from '@mui/material';

import { DateFormatter, SimpleFormat } from '@waypoint/react-formatters';

type Props = {
  includeConnector: boolean;
  event: FTimelineLogItemFragment;
};

export default function TimelineEvent({ includeConnector, event }: Props) {
  const icon = getTimelineLogItemIcon(event);
  const label = getTimelineLogItemLabel(event);
  const eventMessageSx = {
    wordBreak: 'break-word',
    '> p': { m: 0 },
    a: { color: 'primary.main', textDecoration: 'none' },
    'a:hover': { textDecoration: 'underline' },
  };

  const renderTimelineConnector = () => {
    return includeConnector ? null : <TimelineConnector />;
  };
  return (
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot sx={{ p: 1 }} variant="outlined">
          {icon}
        </TimelineDot>
        {renderTimelineConnector()}
      </TimelineSeparator>
      <TimelineContent>
        <Stack direction="row" spacing={2} alignItems="top" justifyContent="space-between" mt={2}>
          <Typography component="div" fontWeight="fontWeightMedium" sx={{ mb: 0.5 }}>
            {label}
          </Typography>
          <Typography whiteSpace="nowrap" variant="body2" color="text.secondary">
            <DateFormatter value={event.createdAt} template="full" />
          </Typography>
        </Stack>
        <Typography component="div" variant="body2" color="text.secondary" gutterBottom sx={eventMessageSx}>
          <SimpleFormat value={event.message} />
        </Typography>
      </TimelineContent>
    </TimelineItem>
  );
}
